/*
 * Copyright © 2025 Gavin Sawyer. All rights reserved.
 */

import { inject, Injectable }               from "@angular/core";
import { REQUEST }                          from "@bowstring/injection-tokens";
import { type Request }                     from "express";
import { type Timestamp as AdminTimestamp } from "firebase-admin/firestore";
import { type Timestamp }                   from "firebase/firestore";


@Injectable({ providedIn: "root" })
export class TimestampService {

  private readonly request: Request | null = inject<Request | null>(
    REQUEST,
    { optional: true },
  );

  public getDate(timestamp: AdminTimestamp | Timestamp): Date {
    return new Date(timestamp.seconds * 1000 - (this.request?.headersDistinct["timezone-offset"]?.[0] ? parseInt(this.request.headersDistinct["timezone-offset"][0]) - new Date().getTimezoneOffset() : 0) * 60000);
  }

}
